/**
 * Heavy Weather Checklist
 * When heavy weather expected
 * Regulatory: WBC3 10.6, 19.2
 */

export const HEAVY_WEATHER_CHECKLIST = {
  id: 'heavy_weather',
  name: 'Heavy Weather',
  description: 'When heavy weather expected',
  icon: 'CloudRain',
  regulatory: 'WBC3 10.6, 19.2',
  isCustomisable: true,
  items: [
    { id: 'hw_1', text: 'Go/no-go decision made', required: true },
    { id: 'hw_2', text: 'Shelter options identified', required: true },
    { id: 'hw_3', text: 'All hatches and doors secured', required: true },
    { id: 'hw_4', text: 'Loose gear secured (deck and interior)', required: true },
    { id: 'hw_5', text: 'Lifejackets accessible - crew aware', required: true },
    { id: 'hw_6', text: 'Crew briefed on conditions and duties', required: true },
    { id: 'hw_7', text: 'Bilge alarms checked', required: false }
  ]
};
